"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Handle_1 = __importDefault(require("./Handle/Handle"));
var rc_slider_1 = __importStar(require("rc-slider"));
var react_1 = require("react");
var main_1 = require("../../main");
var reserveSpace_1 = __importDefault(require("../../utils/reserveSpace"));
var BelowText_1 = __importDefault(require("../BelowText/BelowText"));
/**
 * The Slider allows users to make selections from a range of values.
 */
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: 0,
            from: 0,
            to: 0
        };
        _this.genClasses = function () {
            var _a = _this.props, disabled = _a.disabled, fluid = _a.fluid;
            var classes = 'ui slider-wrap';
            if (disabled) {
                classes += ' disabled';
            }
            if (fluid) {
                classes += ' fluid';
            }
            return classes;
        };
        _this.genHandle = function (RcProps) {
            var dragging = RcProps.dragging, index = RcProps.index, reverse = RcProps.reverse, style = RcProps.style, ref = RcProps.ref, value = RcProps.value, handleProps = __rest(RcProps, ["dragging", "index", "reverse", "style", "ref", "value"]);
            return (React.createElement(Handle_1.default, __assign({}, handleProps),
                React.createElement("div", { className: "slider-handle-tooltip" }, value)));
        };
        _this.handleChangeWrap = function (value, field) {
            clearTimeout(_this.debouncer);
            var _a = _this.props, min = _a.min, max = _a.max;
            var newValue = parseInt(value, 10);
            if (newValue > max) {
                newValue = max;
            }
            if (newValue < min) {
                newValue = min;
            }
            _this.handleChange(newValue, field);
            _this.debounce(newValue, field);
        };
        _this.handleChange = function (value, field) {
            var onChange = _this.props.onChange;
            var update = {};
            if (typeof value === 'number') {
                update.value = value;
            }
            if (Array.isArray(value)) {
                update.from = value[0];
                update.to = value[1];
            }
            if (field) {
                update[field] = value;
            }
            _this.setState(update);
            if (onChange) {
                onChange(value);
            }
        };
        _this.debounce = function (value, field) {
            var step = _this.props.step;
            var newValue = value;
            if (step) {
                clearTimeout(_this.debouncer);
                _this.debouncer = setTimeout(function () {
                    var quotient = Math.floor(newValue / step);
                    var remainder = newValue % step;
                    var low = quotient * step;
                    var high = quotient * step + step;
                    if (remainder >= step / 2) {
                        newValue = high;
                    }
                    else {
                        newValue = low;
                    }
                    _this.handleChange(newValue, field);
                }, 300);
            }
        };
        return _this;
    }
    Slider.prototype.componentDidMount = function () {
        var min = this.props.min;
        if (typeof min === 'number') {
            this.setState({ value: min });
        }
    };
    Slider.prototype.componentWillUnmount = function () {
        clearTimeout(this.debouncer);
    };
    Slider.prototype.render = function () {
        var _this = this;
        var _a = this.props, min = _a.min, max = _a.max, step = _a.step, disabled = _a.disabled, value = _a.value, showInput = _a.showInput, label = _a.label, vertical = _a.vertical, className = _a.className, children = _a.children, onChange = _a.onChange, fluid = _a.fluid, helperText = _a.helperText, error = _a.error, useRange = _a.useRange, from = _a.from, to = _a.to, cleanedProps = __rest(_a, ["min", "max", "step", "disabled", "value", "showInput", "label", "vertical", "className", "children", "onChange", "fluid", "helperText", "error", "useRange", "from", "to"]);
        var dots = step ? true : false;
        var validRangeValues = Boolean(from && to);
        return (React.createElement("div", __assign({ className: this.genClasses() }, cleanedProps),
            useRange ? (React.createElement("div", { className: "ui slider" },
                showInput && (React.createElement(main_1.Input, { className: "from-input", type: "number", value: from ? from.toString() : this.state.from.toString(), onChange: function (value) { return _this.handleChangeWrap(value, 'from'); }, disabled: disabled })),
                React.createElement(rc_slider_1.Range, { handle: this.genHandle, onChange: this.handleChange, value: validRangeValues ? [from, to] : [this.state.from, this.state.to], step: step, dots: dots, max: max, min: min, disabled: disabled }),
                React.createElement("span", { className: "max-value" }, max),
                showInput && (React.createElement(main_1.Input, { className: "to-input", type: "number", value: to ? to.toString() : this.state.to.toString(), onChange: function (value) { return _this.handleChangeWrap(value, 'to'); }, disabled: disabled })))) : (React.createElement("div", { className: "ui slider" },
                label && React.createElement(main_1.InputLabel, { label: label }),
                React.createElement(rc_slider_1.default, { max: max, min: min, value: value || this.state.value, step: step, dots: dots, handle: this.genHandle, onChange: this.handleChange, disabled: disabled }),
                React.createElement("span", { className: "max-value" }, max),
                showInput && (React.createElement(main_1.Input, { className: "value-input", type: "number", value: value ? value.toString() : this.state.value.toString(), onChange: function (value) { return _this.handleChangeWrap(value, 'value'); }, disabled: disabled })))),
            reserveSpace_1.default(this.props) && (React.createElement(BelowText_1.default, { helperText: helperText, error: error }))));
    };
    Slider.defaultProps = {
        min: 0,
        from: 0,
        to: 0,
        max: 100,
        showInput: false
    };
    return Slider;
}(react_1.Component));
exports.default = Slider;
